// import React from 'react';

// import {
//   TextNodeModal,
//   TextSnippetNodeModal,
//   NoteNodeModal,
//   DocumentNodeModal,
//   ImageNodeModal,
//   ProtocolNodeModal,
//   RisSearchModal,
//   SurfaceNodeModal,
//   QuestionnaireNodeModal,
//   BackgroundNodeModal,
// } from 'routes/surface/style';
import LinkArrow from 'components/canvas/components/link-arrow';
import CollaboratingUsersCursors, {
  useCollaboratingCursorListeners,
} from 'routes/surface/components/collaborating-users-cursors';
import SurfaceSubscriptionListeners from 'routes/surface/components/surface-subscriptions-listeners';
import useNodeSearchParams from 'routes/surface/hooks/use-node-search-params';
import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
import { useHistory, useParams } from 'react-router-dom';
import { configuration } from 'components/pspdf';
import { Line } from 'react-konva';
import useFetchSurfaceNodes from 'components/canvas/components/nodes/hooks/use-fetch-surface-nodes';
// import { Container } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import {
  Fab,
  // FormControlLabel,
  ListItemText,
  Toolbar,
} from '@material-ui/core';
// import styled from 'styled-components';
import useFetchLoggedUser from 'hooks/use-fetch-logged-user';
import { useQuery } from '@apollo/client';
import { homeSurfaceQuery } from 'graphql/surface/queries/home-surface';
import client from 'services/apollo-client';

import React from 'react';
import styled from 'styled-components';
import { templates as allTemplates } from 'routes';
import useMutation from 'hooks/use-mutation';
import { createSurfaceMutation } from 'graphql/surface/mutations/create-surface';
import { pick } from 'lodash';
import toast from 'services/toast';
import { createSurfaceNoteNodeMutation } from 'graphql/surface-node/mutations/surface-note-node/create-surface-note-node';
import {
  Div,
  HeaderStyledLogoIconImmo,
  HeaderStyledLogoIconImmoText,
} from 'routes/list';

import { yellow } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from 'styled-components';
import { createQuestionnaireMutation } from 'graphql/surface/mutations/create-questionaire';
import { media } from 'styles/settings';
import { withPortratitGuard } from 'routes/share/template-page/guard';
import { green } from '@material-ui/core/colors';

const CenteredTitle = styled.h1`
  text-align: center;
  color: ${({ theme }) => theme.text};
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const Label = styled.label`
  margin-bottom: 5px;
  color: ${({ theme }) => theme.text};
`;
const Form = styled.form`
  width: 60%;
  margin: auto;
  ${media.mediaQueries.mobile`
  width: 100%;
  padding-bottom:  200px;
  `}
`;

const TextInput = styled.input`
  padding: 5px;
  margin-top: 4px;
  margin-bottom: 4px;
`;

const Dropdown = styled.select`
  padding: 5px;
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
`;
const Type = ({ type }) => {
  var text = '';
  switch (type) {
    case 'document':
      text = 'Upload:';
      break;
    case 'hint':
      text = 'Hinweis:';
      break;
    case 'boolean':
      text = 'Entscheidungsfrage:';
      // Expected output: "Mangoes and papayas are $2.79 a pound."
      break;
    case 'text':
      text = 'Offene Frage:';
      // Expected output: "Mangoes and papayas are $2.79 a pound."
      break;
    case 'number':
      text = 'Frage(Zahl):';
      // Expected output: "Mangoes and papayas are $2.79 a pound."
      break;
    default:
    // console.log(`Sorry, we are out of ${expr}.`);
  }
  return <Label> {text}</Label>;
};

export const MyCheckbox = ({ initial, name, label }) => {
  const [isChecked, setIsChecked] = React.useState(initial);

  const checkHandler = () => {
    setIsChecked(!isChecked);
  };
  return (
    // <div>
    //   <input type="checkbox" id="checkbox" checked={isChecked} />
    //   <label htmlFor="checkbox">I agree to Terms of Service </label>
    //   <p>The checkbox is {isChecked ? "checked" : "unchecked"}</p>
    // </div>
    <FormControlLabel
      sx={{
        display: 'inline',
        fontWeight: 'bold',
        // mx: 0.5,
        fontSize: 14,
      }}
      name={name}
      // required
      control={<Checkbox checked={isChecked} onChange={checkHandler} />}
      label={label}
    />
  );
};

const MyForm = ({ logo, scope, onDone }) => {
  const templates = allTemplates.filter((t) => t.scope === scope);

  console.log(
    ' SCOPE ',
    scope,
    templates.map((t) => t.scope),
    allTemplates.map((t) => t.scope),
  );

  const { id } = useParams<{ id: string }>();
  const [textInput1, setTextInput1] = React.useState('');
  const [textInput2, setTextInput2] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState('');
  const history = useHistory();

  const handleInputChange1 = (event) => {
    setTextInput1(event.target.value);
  };

  const handleInputChange2 = (event) => {
    setTextInput2(event.target.value);
  };

  const handleDropdownChange = (event) => {
    setSelectedOption('');
    const x = event.target.value;
    setTimeout(() => {
      setSelectedOption(x);
    }, 1);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('Form submitted!');
    console.log('Input 1:', textInput1);
    console.log('Input 2:', textInput2);
    console.log('Selected option:', selectedOption);
  };

  const [createSurface] = useMutation(createSurfaceMutation);
  const [createQuestionaire] = useMutation(createQuestionnaireMutation);
  const [createSurfaceNode] = useMutation(createSurfaceNoteNodeMutation);

  // const [updateSurface] = useMutation(updateSurfaceMutation);
  //
  // const initialValues = merge(data ?? { name: '' });

  // const submitLabel = data?.id ? t('Update cell') : t('Insert cell');

  function surfaceOperation(data) {
    const keys = ['name', 'surface', 'position', 'description'];

    const input = pick(data, keys);

    // if (input.id) {
    //   return updateSurface({ variables: { input } });
    // }

    return createSurface({ variables: { input } });
  }

  function surfaceNodeOperation(data) {
    const keys = ['name', 'surface', 'position'];

    // const input = pick(data, keys);

    // if (input.id) {
    //   return updateSurface({ variables: { input } });
    // }

    return createSurfaceNode({ variables: { input: data } });
  }

  function surfaceQuestionaireOperation(data) {
    const keys = ['name', 'surface', 'position'];

    // const input = pick(data, keys);

    // if (input.id) {
    //   return updateSurface({ variables: { input } });
    // }

    return createQuestionaire({ variables: { input: data } });
  }

  const navigateToSurface = React.useCallback((surfaceId: string) => {
    history.push('/immo-ox/list/' + surfaceId);
  }, []);

  async function onSubmit(input) {
    console.log('inpout', input.target.elements);
    input.preventDefault();
    let data = Array.from(input.target.elements);
    console.log('inpout');

    data = data.map((element) => {
      return {
        name: element.name,
        checked: element.checked,
        value: element.value,
        type: element.type,
      };
    });

    const map = new Map(data.map((object) => [object.name, object]));

    console.log('MAP ', map);
    var questions: any[] = [];

    selectredTewmplate?.entries.map((entry) => {
      const key = entry.id;
      console.log('ENTRY ', entry, key);
      const text = map.get(`${key}-text`);
      const required = map.get(`${key}-required`);
      const used = map.get(`${key}-used`);

      // console.log('QQQ', entry, used, text, required);
      if (used.checked) {
        questions.push({
          required: required.checked,
          question: text.value,
          type: entry.type,
        });
      }
    });

    questions = questions.map((q, index) => {
      return { ...q, order: index };
    });

    console.log('QQQ', questions, selectredTewmplate.id);
    // if (questions) {
    //   return;
    // }

    const response = await surfaceOperation({
      name: textInput1,
      surface: id,
      description: textInput2,
    });

    // params.variables.input = pick(params.variables.input, [
    //   'name',
    //   'text',
    //   'slateData',
    //   'surface',
    //   'position',
    //   'snippets',
    // ]);

    if (response.isFailure) {
      return toast.error(response.getErrorMessage());
    }
    console.log('response.data ', response.data);
    const resp2 = await surfaceQuestionaireOperation({
      surface: response.data.data.id,
      questions,
      templateId: selectredTewmplate?.id,
    });
    if (resp2.isFailure) {
      return toast.error(resp2.getErrorMessage());
    }

    // modal.hide();

    // if (!input.surface) {
    //   // Close modal and navigate to newly created surface
    //   history.push('/surface/' + response.getField('data.id'));
    // } else {
    //   saveNodeInCache(response.getField('data'));
    //   setHighestZIndexToNode(response.getField('data'));
    // }

    // if (input.id) {
    //   return toast.success(t('Surface successfully updated'));
    // }

    toast.success('Erfolgreich erstellt');
    if (scope == 'immoox') {
      navigateToSurface(id);
    }
    if (scope == 'cortlex') {
      onDone();
    }
  }

  const selectredTewmplate = templates.find((t) => t.id == selectedOption);

  console.log('SELECTED- TEMPLATE', selectredTewmplate);

  return (
    <Div>
      {logo && <HeaderStyledLogoIconImmo />}
      {logo && <HeaderStyledLogoIconImmoText />}
      <Toolbar></Toolbar>
      <Container maxWidth="lg">
        <Box
          component="div"
          sx={{
            mt: 4,
            display: 'flex',
            flexDirection: 'column',
            height: '80vh',
            overflow: 'hidden',
            overflowY: 'scroll',
            // justifyContent="flex-end" # DO NOT USE THIS WITH 'scroll'
          }}>
          {/* <FormContainer> */}
          <CenteredTitle>Wählen sie ihre Vorlage aus. </CenteredTitle>
          <Form onSubmit={onSubmit}>
            <FormGroup>
              <Label>Titel:</Label>
              <TextInput
                name={'name'}
                type="text"
                value={textInput1}
                onChange={handleInputChange1}
              />
            </FormGroup>
            <FormGroup>
              <Label>Notiz:</Label>
              <TextInput
                type="text"
                value={textInput2}
                onChange={handleInputChange2}
              />
            </FormGroup>
            <FormGroup>
              <Label>Vorlage:</Label>
              <Dropdown value={selectedOption} onChange={handleDropdownChange}>
                <option value="">-</option>
                {templates.map((t) => (
                  <option value={t.id}>{t.title}</option>
                ))}
                {/*
            <option value="Option 2">Option 2</option>
            <option value="Option 3">Option 3</option> */}
              </Dropdown>
            </FormGroup>
            {selectredTewmplate != null && (
              <FormGroup>
                {}
                <Label>Fragen:</Label>

                {}
                {/* {JSON.stringify(selectredTewmplate)} */}
                {selectredTewmplate.entries.map((t) => {
                  return (
                    <Stack
                      key={t.id + '-' + selectredTewmplate.id}
                      sx={{ mt: 2, mb: 2 }}>
                      {/* <span>
                        <Label>Frage: </Label> :
                      </span> */}
                      <Type type={t.type} />

                      <TextInput
                        name={`${t.id}-text`}
                        type="text"
                        defaultValue={t.text}
                        // disabled={t.asked == false}
                      />
                      <span>
                        <Box sx={{ ml: 4 }}></Box>
                        <MyCheckbox
                          label={`Wird abgefragt`}
                          name={`${t.id}-used`}
                          initial={t.asked != false}
                        />
                        {/* <FormControlLabel
                        name={`${t.key}-used`}
                        required
                        control={<Checkbox checked={true} />}
                        label="Verwendet"
                      /> */}
                        {/* <FormControlLabel
                        name={}
                        required
                        control={<Checkbox checked={t.required} />}
                        label=
                      /> */}
                        <MyCheckbox
                          label="Muss ausgefüllt werden"
                          name={`${t.id}-required`}
                          initial={t.required}
                        />
                      </span>
                    </Stack>
                  );
                })}
                {/* <TextInput type="text" value={} onChange={handleInputChange2} /> */}
              </FormGroup>
            )}

            <SubmitButton type="submit">Erstellen</SubmitButton>
          </Form>
        </Box>
        {/* </FormContainer> */}
      </Container>
    </Div>
  );
};

const theme = createTheme({
  palette: {
    primary: {
      main: yellow[500],
    },
    text: {
      primary: 'white',
    },
  },
});

const theme2 = createTheme({
  palette: {
    primary: {
      main: '#DCAA4F',
    },
    text: {
      primary: '#000',
    },
  },
});

export function ThemedTemplate(props) {
  const themeStyled = useTheme();
  return (
    <ThemeProvider theme={{ ...theme, ...themeStyled }}>
      <MyForm {...props} logo={true} scope={'immoox'} />
    </ThemeProvider>
  );
}

export function CortlexThemedTemplate(props) {
  const themeStyled = useTheme();
  console.log(' CURRENT THEME ', themeStyled);
  return (
    <ThemeProvider theme={{ ...theme2, ...themeStyled }}>
      <MyForm {...props} logo={false} scope={'cortlex'} />
    </ThemeProvider>
  );
}

// return <ThemeProvider theme={theme}>...</ThemeProvider>;

export default withPortratitGuard(ThemedTemplate);

// export default MyForm;
